var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodatafaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 116,
    viewBox: "0 0 126 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 126,
    height: 116,
    transform: "translate(125 255)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M226.78,388.357s.38-1.917,1.868-2.33a6.325,6.325,0,0,0,2.063-.868A4.029,4.029,0,0,1,226.78,388.357Z",
    transform: "translate(-226.78 -385.16)",
    fill: "#ce8045"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(-125 -255)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAQs-rafiki",
    transform: "translate(68.89 97.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-61",
    transform: "translate(56.11 249.427)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-61",
    cx: 63,
    cy: 3.678,
    rx: 63,
    ry: 3.678,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letters--inject-61",
    transform: "translate(56.422 174.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M69.544,190.384v11.125h19.47v11.048H69.544v17.354H57.07V179.33H91.658v11.047Z",
    transform: "translate(-57.07 -177.874)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M177.839,220.743H159.191l-3.467,9.826H143L162.466,180h12.285l19.528,50.572H181.3ZM174.193,210.2l-5.67-16.185-5.67,16.185Z",
    transform: "translate(-115.079 -178.327)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M336.11,232.287a14.8,14.8,0,0,1-12.347,6.356c-7.181,0-11.905-2.817-19.278-11.629-11.59-2.242-19.655-12.5-19.655-25.864,0-15.174,10.4-26.3,24.506-26.3s24.506,11.125,24.506,26.3c0,11.486-5.985,20.662-14.992,24.418,1.764,2.167,3.275,2.889,5.166,2.889a8.857,8.857,0,0,0,6.677-3.538ZM309.336,215.6c6.677,0,11.905-5.706,11.905-14.446S316.013,186.7,309.336,186.7s-11.909,5.706-11.909,14.449S302.659,215.6,309.336,215.6Z",
    transform: "translate(-210.825 -174.85)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M351.808,179.127a.163.163,0,0,1-.023-.325,20.41,20.41,0,0,1,4.088-.143.163.163,0,0,1,.153.172.172.172,0,0,1-.175.153,19.96,19.96,0,0,0-4.019.14Z",
    transform: "translate(-255.922 -177.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M304.182,190.748a.153.153,0,0,1-.1-.033.162.162,0,0,1-.033-.227,24.1,24.1,0,0,1,11.681-8.516.159.159,0,0,1,.2.1.166.166,0,0,1-.1.2,23.782,23.782,0,0,0-11.522,8.4.166.166,0,0,1-.13.065Z",
    transform: "translate(-223.779 -179.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M88.379,184.075H85.932a.162.162,0,0,1,0-.325h2.447a.162.162,0,0,1,0,.325Z",
    transform: "translate(-76.445 -180.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M61.842,191.954a.162.162,0,0,1-.162-.162v-7.879a.162.162,0,0,1,.162-.162h5.7a.166.166,0,0,1,.162.162.162.162,0,0,1-.162.162H62v7.707a.162.162,0,0,1-.162.172Z",
    transform: "translate(-60.182 -180.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M231.082,184.075h-2.85a.162.162,0,0,1-.162-.162.166.166,0,0,1,.162-.162h2.85a.166.166,0,0,1,.162.162.162.162,0,0,1-.162.162Z",
    transform: "translate(-172.508 -180.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M195.25,192.9a.127.127,0,0,1-.059,0,.159.159,0,0,1-.094-.208l3.288-8.793a.166.166,0,0,1,.153-.107h4.581a.162.162,0,0,1,0,.325h-4.468L195.4,192.8A.159.159,0,0,1,195.25,192.9Z",
    transform: "translate(-150.241 -180.885)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-61",
    transform: "translate(106.864 237.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M226.78,388.357s.38-1.917,1.868-2.33a6.325,6.325,0,0,0,2.063-.868A4.029,4.029,0,0,1,226.78,388.357Z",
    transform: "translate(-222.079 -379.949)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281",
    transform: "translate(4.701 5.211)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M226.78,388.357s.38-1.917,1.868-2.33a6.325,6.325,0,0,0,2.063-.868A4.029,4.029,0,0,1,226.78,388.357Z",
    transform: "translate(-226.78 -385.16)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M226.706,390.642a.114.114,0,0,1-.071-.026.1.1,0,0,1,0-.149,7.376,7.376,0,0,1,2.752-1.914.106.106,0,1,1,.081.2,7.188,7.188,0,0,0-2.674,1.859A.1.1,0,0,1,226.706,390.642Z",
    transform: "translate(-221.959 -382.234)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M217.146,386.227s.114-3.054-2-4.224a10.172,10.172,0,0,1-2.83-2.063A6.3,6.3,0,0,0,217.146,386.227Z",
    transform: "translate(-212.312 -376.425)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282",
    transform: "translate(0 3.515)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M217.146,386.227s.114-3.054-2-4.224a10.172,10.172,0,0,1-2.83-2.063A6.3,6.3,0,0,0,217.146,386.227Z",
    transform: "translate(-212.312 -379.94)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M218.185,389.61a.1.1,0,0,1-.091-.055,13.225,13.225,0,0,0-3.928-4.27.107.107,0,0,1,.123-.175,13.465,13.465,0,0,1,3.99,4.341.107.107,0,0,1-.042.146A.137.137,0,0,1,218.185,389.61Z",
    transform: "translate(-213.532 -379.902)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M225.961,386.649l-.325-.062a20.188,20.188,0,0,0-.026-7.636l.325-.062A20.5,20.5,0,0,1,225.961,386.649Z",
    transform: "translate(-221.289 -375.716)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M223.408,369.928c.065.374.6,1.647.975,1.582s.442-1.446.377-1.82a.686.686,0,0,0-1.352.237Z",
    transform: "translate(-219.796 -369.123)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M227.017,380.587c-.065-.374-.6-1.647-.975-1.582s-.442,1.446-.377,1.82a.686.686,0,0,0,1.352-.237Z",
    transform: "translate(-221.311 -375.792)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M218.838,378.147c.374-.065,1.647-.6,1.582-.975s-1.446-.442-1.82-.377a.686.686,0,1,0,.237,1.352Z",
    transform: "translate(-216.174 -374.287)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M229.5,374.5c-.374.065-1.647.6-1.582.975s1.446.442,1.82.377a.686.686,0,0,0-.237-1.352Z",
    transform: "translate(-222.844 -372.745)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M219.4,373.081c.325.218,1.589.741,1.807.432s-.708-1.335-1.017-1.553a.686.686,0,1,0-.79,1.121Z",
    transform: "translate(-216.898 -370.954)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M229.448,378.715c-.325-.218-1.589-.741-1.807-.432s.708,1.335,1.017,1.553a.686.686,0,0,0,.79-1.121Z",
    transform: "translate(-222.639 -375.242)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M221.991,380.538c.218-.325.741-1.589.432-1.807s-1.335.708-1.553,1.017a.686.686,0,0,0,1.121.79Z",
    transform: "translate(-218.005 -375.587)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M227.625,370.516c-.218.325-.741,1.589-.432,1.807s1.335-.708,1.553-1.017a.686.686,0,0,0-1.121-.79Z",
    transform: "translate(-222.293 -369.867)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M224.164,376.19a.812.812,0,1,0,.65-.939A.812.812,0,0,0,224.164,376.19Z",
    transform: "translate(-220.305 -373.25)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M224.164,376.19a.812.812,0,1,0,.65-.939A.812.812,0,0,0,224.164,376.19Z",
    transform: "translate(-220.305 -373.25)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M220.85,406.066h-4.49L215.3,401.78h6.612Z",
    transform: "translate(-214.329 -391.169)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M222.839,412.82v1.189h-.881v-.224h-.825v.224h-1.495v-.224h-.829v.224h-.78V412.82Z",
    transform: "translate(-216.172 -398.622)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-61",
    transform: "translate(149.033 188.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M369.454,261.872H371.1a39.52,39.52,0,0,0,.227-7.012c-.224-3.672.393-3.9-.946-6.135a2.07,2.07,0,0,0-.621-.718.858.858,0,0,0-.907-.049C368.59,248.118,369.48,256.907,369.454,261.872Z",
    transform: "translate(-360.127 -238.223)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283",
    transform: "translate(8.68 9.629)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M369.454,261.872H371.1a39.52,39.52,0,0,0,.227-7.012c-.224-3.672.393-3.9-.946-6.135a2.07,2.07,0,0,0-.621-.718.858.858,0,0,0-.907-.049C368.59,248.118,369.48,256.907,369.454,261.872Z",
    transform: "translate(-368.807 -247.852)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M405.6,344.37l.747,3.857,1.868-.046-.357-4.081Z",
    transform: "translate(-384.965 -303.197)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M414.078,355.972a.042.042,0,0,1-.029-.039.039.039,0,0,1,.023-.042c.029,0,.7-.325,1-.211a.231.231,0,0,1,.127.114.166.166,0,0,1,0,.188.79.79,0,0,1-.549.091A3.218,3.218,0,0,1,414.078,355.972Zm.146-.045c.325.071.8.11.89,0,0-.016.029-.039,0-.1a.117.117,0,0,0-.078-.068.24.24,0,0,0-.081-.016A1.969,1.969,0,0,0,414.224,355.927Z",
    transform: "translate(-390.668 -310.998)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M414.036,355a.062.062,0,0,1-.016-.042,1.251,1.251,0,0,1,.348-.679.325.325,0,0,1,.247-.055c.117.023.15.088.15.136.023.208-.452.565-.679.65h-.02A.045.045,0,0,1,414.036,355Zm.543-.7a.24.24,0,0,0-.156.039,1.023,1.023,0,0,0-.289.539c.237-.114.552-.4.552-.523,0,0,0-.042-.081-.055Z",
    transform: "translate(-390.649 -310.025)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M408.09,355.424l-1.992-.175a.166.166,0,0,0-.169.111l-.5,1.589a.266.266,0,0,0,.169.325h.055c.721.052,1.361.068,2.255.149,1.056.094.777.2,2.015.325.747.075.975-.76.65-.832a2.881,2.881,0,0,1-2.06-1.329A.65.65,0,0,0,408.09,355.424Z",
    transform: "translate(-384.842 -310.723)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M406.078,346.833l2-.279-.214-2.453-2.258.27Z",
    transform: "translate(-384.965 -303.197)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M360.451,284s11.766.026,12.328,3.249,1.371,17.871,1.371,17.871l-2.726.4s-1.924-8.1-3.136-16.386c0,0-12.474,1.1-13.127-.63a9.731,9.731,0,0,1-.14-4.348Z",
    transform: "translate(-350.691 -262.625)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M360.451,284s11.766.026,12.328,3.249,1.371,17.871,1.371,17.871l-2.726.4s-1.924-8.1-3.136-16.386c0,0-12.474,1.1-13.127-.63a9.731,9.731,0,0,1-.14-4.348Z",
    transform: "translate(-350.691 -262.625)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M404.509,347.88l3.34-.478-.049-1.2-3.571.426Z",
    transform: "translate(-384.04 -304.615)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M364.408,288.4v.088a8.257,8.257,0,0,0-.088-1.183c-.377-2.161-6.014-2.96-8.328-3.2l-2.811.084a8.215,8.215,0,0,0,.117,3.675C353.851,289.332,364.408,288.4,364.408,288.4Z",
    transform: "translate(-349.468 -262.7)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M352.519,250.251l-.65,5.29c.244.507.809,1.748.442,1.742a21.089,21.089,0,0,0-3.311,1.95l-5.15-2.057.354-1.452c-.1-.458-.569-3.165-.975-5.547l-.036-.218-.4-2.551-.143-.913h0c-.042-.393-.146-.715-.179-.929a.326.326,0,0,1,0-.149.452.452,0,0,1,.163-.292l.019-.016.1-.078c1.875-1.355,6.732-.107,8.156.263.2.049.588.292.585.5l.25.734.53,1.56c.052.153.094.309.133.468a4.921,4.921,0,0,1,.11,1.7Z",
    transform: "translate(-342.343 -235.901)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M385.42,345.23l.127,3.854,1.868-.049.266-4.075Z",
    transform: "translate(-371.342 -303.778)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M391.862,357.344a.039.039,0,0,1-.023-.042.049.049,0,0,1,.036-.039c.029,0,.751-.159,1.017.016a.221.221,0,0,1,.1.137.162.162,0,0,1-.055.182.764.764,0,0,1-.556-.033A3.011,3.011,0,0,1,391.862,357.344Zm.153,0c.325.146.751.283.868.195.016,0,.036-.029.023-.091a.117.117,0,0,0-.062-.084.412.412,0,0,0-.078-.036,2.011,2.011,0,0,0-.751,0Z",
    transform: "translate(-375.674 -312.038)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M391.837,356.258a.039.039,0,0,1,0-.042,1.178,1.178,0,0,1,.487-.588.325.325,0,0,1,.25,0c.111.049.127.117.117.166-.026.208-.565.452-.8.478h-.02A.029.029,0,0,1,391.837,356.258Zm.679-.556a.224.224,0,0,0-.159,0,1.03,1.03,0,0,0-.4.461c.257-.059.627-.266.65-.387,0,0,0-.046-.065-.075Z",
    transform: "translate(-375.67 -310.963)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M385.432,355.444l-1.9-.611a.156.156,0,0,0-.185.072l-.842,1.439a.263.263,0,0,0,.094.364l.049.026c.692.208,1.3.364,2.167.65,1.007.325.715.364,1.894.76.712.237,1.1-.533.812-.669a2.852,2.852,0,0,1-1.716-1.751A.65.65,0,0,0,385.432,355.444Z",
    transform: "translate(-369.346 -310.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M351.043,285s10.453.65,11.015,3.9-1.235,17.413-1.235,17.413l-2.726.185s-.588-9.592-.526-15.7c0,0-11.164.682-11.818-1.049a10.761,10.761,0,0,1-.136-4.568Z",
    transform: "translate(-344.341 -263.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M349.288,284.129s10.453.65,11.015,3.9-1.235,17.413-1.235,17.413l-2.726.185s-.588-9.592-.526-15.7c0,0-9.621,1.027-11.905-.552-2.512-1.735.114-5.663.114-5.663Z",
    transform: "translate(-342.586 -262.43)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M349.288,284.129s10.453.65,11.015,3.9-1.235,17.413-1.235,17.413l-2.726.185s-.588-9.592-.526-15.7c0,0-9.621,1.027-11.905-.552-2.512-1.735.114-5.663.114-5.663Z",
    transform: "translate(-342.586 -262.43)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M383.031,349.041l3.35-.214.11-1.306-3.681.257Z",
    transform: "translate(-369.58 -305.506)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M353.846,234.41c.13,1.063.227,2.6-.556,3.249.952.65.718,1.54,1.4,2.46a3.215,3.215,0,0,0,1.5-.049c.026-.019.234.036.25,0,.916-1.4.114-2.187.114-2.187-.611.3-.591-.767-.325-1.566Z",
    transform: "translate(-349.652 -229.148)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M358.445,239.187a3.21,3.21,0,0,1,.162-1.111l-.426-.348-1.3-.728C356.576,237.708,357.558,238.894,358.445,239.187Z",
    transform: "translate(-352.038 -230.897)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M364.339,220.59a4.59,4.59,0,0,1,2,3.857,10.192,10.192,0,0,1-.461,2.749,4.95,4.95,0,0,1-2.164-3.048A4.643,4.643,0,0,1,364.339,220.59Z",
    transform: "translate(-356.609 -219.819)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M354.668,222.55c-.3,1.735-.461,2.469.195,3.535a2.242,2.242,0,0,0,3.99,0c.725-1.449,1.108-4.042-.416-5.118a2.4,2.4,0,0,0-3.769,1.576Z",
    transform: "translate(-350.406 -219.771)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M365.961,231.71a3.877,3.877,0,0,0,.286,1.007.611.611,0,0,1-.517-.026Z",
    transform: "translate(-358.05 -227.326)",
    fill: "#ba4d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M363.525,235.5a1.5,1.5,0,0,0,.211.026.042.042,0,0,0,0-.081,1.14,1.14,0,0,1-.9-.487.043.043,0,0,0-.075.042A1.193,1.193,0,0,0,363.525,235.5Z",
    transform: "translate(-356.04 -229.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M362.642,226.619a.085.085,0,0,0,.1,0,1,1,0,0,1,.8-.042.084.084,0,1,0,.059-.156,1.192,1.192,0,0,0-.949.058.088.088,0,0,0-.023.117.062.062,0,0,0,.019.023Z",
    transform: "translate(-355.943 -223.707)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M368.961,227.827a.085.085,0,0,0,.137-.091.832.832,0,0,0-.533-.552.081.081,0,0,0-.1.059.084.084,0,0,0,.058.1.676.676,0,0,1,.416.445A.085.085,0,0,0,368.961,227.827Z",
    transform: "translate(-359.893 -224.268)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M355.14,247.24s1.972,1.381,2.765.032v1.3l-.016,1.569-.26.364-.5-.162-.582-1.082-.237-.383Z",
    transform: "translate(-350.901 -237.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M351.814,243.553s2.18,3.025,2.736,3.967.185-3.574.185-3.574.325-.348.89.172a15.713,15.713,0,0,1,.556,2.171c-.068.162-.809.231-.809.231s.429.5.344.786a1.624,1.624,0,0,1-.881.806,5.794,5.794,0,0,1-2.092-1.072c-.094-.244.445-.591.445-.591s-1.248.049-1.42-.406-.829-2.505-.829-2.505a.565.565,0,0,1,.874.016Z",
    transform: "translate(-348.065 -235.176)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M351.814,243.553s2.18,3.025,2.736,3.967.185-3.574.185-3.574.325-.348.89.172a15.713,15.713,0,0,1,.556,2.171c-.068.162-.809.231-.809.231s.429.5.344.786a1.624,1.624,0,0,1-.881.806,5.794,5.794,0,0,1-2.092-1.072c-.094-.244.445-.591.445-.591s-1.248.049-1.42-.406-.829-2.505-.829-2.505a.565.565,0,0,1,.874.016Z",
    transform: "translate(-348.065 -235.176)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M352.834,229.181a1.3,1.3,0,0,0,.5.845c.364.266.708-.019.734-.445s-.127-.975-.556-1.085a.578.578,0,0,0-.682.686Z",
    transform: "translate(-349.336 -225.148)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 2.336,
    height: 5.498,
    rx: 1.168,
    transform: "translate(13.885 4.482) rotate(8.63)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M378.75,243.609l.858-.51s.341-1.1.7-1.209a9.836,9.836,0,0,1,.848-.539c.448-.214.679.1.676.783s.247,1.085-.426,1.407-.975.445-.975.445l-1.131.851Z",
    transform: "translate(-366.839 -233.789)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M347.278,251.677a17.874,17.874,0,0,1-1.576,1.111,6.578,6.578,0,0,1-2.083.926l-.4-2.551a1.229,1.229,0,0,1-.14-.208V250Z",
    transform: "translate(-342.759 -239.673)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M354.735,247.582l-.4.253c-.783.491-1.472.907-2.161,1.3a25.175,25.175,0,0,1-3.529,1.576,33.623,33.623,0,0,1-3.6-1.079c-.065-.029-.133-.055-.2-.088a8.573,8.573,0,0,1-1.569-.842,3.3,3.3,0,0,1-.715-.7,1.224,1.224,0,0,1-.14-.208,2.026,2.026,0,0,1-.231-.478,1.839,1.839,0,0,1,.049-1.322,1.3,1.3,0,0,1,.182-.325.538.538,0,0,1,.039-.052l.062-.026a2.21,2.21,0,0,1,3.074.884c.994.3,1.95,1.014,3.444,1.011a7.538,7.538,0,0,0,2.473-.4c.523-.172,1.124-.406,1.878-.731l.552-.24.13.159a4.583,4.583,0,0,1,.627,1.15A.653.653,0,0,1,354.735,247.582Z",
    transform: "translate(-342.092 -236.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M354.735,247.582l-.4.253c-.783.491-1.472.907-2.161,1.3a25.175,25.175,0,0,1-3.529,1.576,33.623,33.623,0,0,1-3.6-1.079c-.065-.029-.133-.055-.2-.088a8.573,8.573,0,0,1-1.569-.842,3.3,3.3,0,0,1-.715-.7,1.224,1.224,0,0,1-.14-.208,2.026,2.026,0,0,1-.231-.478,1.839,1.839,0,0,1,.049-1.322,1.3,1.3,0,0,1,.182-.325.538.538,0,0,1,.039-.052l.062-.026a2.21,2.21,0,0,1,3.074.884c.994.3,1.95,1.014,3.444,1.011a7.538,7.538,0,0,0,2.473-.4c.523-.172,1.124-.406,1.878-.731l.552-.24.13.159a4.583,4.583,0,0,1,.627,1.15A.653.653,0,0,1,354.735,247.582Z",
    transform: "translate(-342.092 -236.501)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M378.445,248.7l-.491.6-1.254-1.969.627-.465Z",
    transform: "translate(-365.455 -237.56)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M378.445,248.7l-.491.6-1.254-1.969.627-.465Z",
    transform: "translate(-365.455 -237.56)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M354.055,218.579c-1.166-.9-3.084.026-3.925,1.241a3.457,3.457,0,0,0,.221,4.11,5.978,5.978,0,0,0,2.148,1.235,4.9,4.9,0,0,1,.448-3.077,4.962,4.962,0,0,1,2.275-2.167A7.527,7.527,0,0,0,354.055,218.579Z",
    transform: "translate(-347.131 -218.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M363.4,219.33a12.578,12.578,0,0,1,1.394,1.443,6.507,6.507,0,0,1,1.413,2.739C366.432,222.079,365.184,219.47,363.4,219.33Z",
    transform: "translate(-356.477 -218.968)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M368.089,230.846c-.032.14.016.27.107.292s.192-.075.224-.214-.016-.27-.1-.289S368.125,230.706,368.089,230.846Z",
    transform: "translate(-359.635 -226.598)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M368.965,230.689l-.325-.059h0v.149A.292.292,0,0,0,368.965,230.689Z",
    transform: "translate(-360.014 -226.597)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M363.249,229.7c-.033.14.016.27.107.289s.192-.071.224-.211,0-.27-.107-.292S363.282,229.558,363.249,229.7Z",
    transform: "translate(-356.368 -225.82)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M364.185,229.539l-.325-.059h0v.149A.289.289,0,0,0,364.185,229.539Z",
    transform: "translate(-356.787 -225.82)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-61",
    transform: "translate(112.238 185.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M276.736,301.432c-3.574,4.348-12.052,12.217-12.052,12.217l-1.625-1.069s6.193-10.469,9.2-12.451c-2.528-4.013-10.755-18.28-10.755-18.28l5.849-2.119s6.619,12.7,9.689,18.677a2.765,2.765,0,0,1-.3,3.025Z",
    transform: "translate(-250.891 -256.589)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M252.16,284.813s5.218,14.336,7.191,20.337c1.738,5.313,7,18.336,7,18.336l1.875-.65S264.9,308.162,263.4,302.69c-1.374-5.027-4.793-20.21-4.793-20.21Z",
    transform: "translate(-244.586 -258.446)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M265.015,381.437a7.183,7.183,0,0,0,1.264,3.077c.169.289-.578.666-1.111.075-.887-.975-.9-1.014-1.651-1.839-.65-.715-1.42-1.5-1.95-2.06a.357.357,0,0,1-.042-.055.283.283,0,0,1,.107-.383l1.54-.877a.169.169,0,0,1,.208.033l1.423,1.573A.913.913,0,0,1,265.015,381.437Z",
    transform: "translate(-250.884 -323.841)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M271.457,385.2h0c.163.273.484.734.757.767a.254.254,0,0,0,.237-.088.15.15,0,0,0,.039-.14c-.062-.26-.877-.575-.975-.608a.045.045,0,0,0-.059.068Zm.936.556h0a.045.045,0,0,1-.016.052.166.166,0,0,1-.146.058c-.159-.016-.387-.24-.621-.6C271.934,385.4,272.341,385.613,272.392,385.759Z",
    transform: "translate(-257.605 -327.741)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M271.48,384.678a.032.032,0,0,0,.023.023c.237.1.858.166,1,0a.166.166,0,0,0-.02-.215.341.341,0,0,0-.231-.136,1.335,1.335,0,0,0-.757.279.042.042,0,0,0,0,.042Zm.952-.1a.049.049,0,0,1,0,.055c-.084.1-.539.094-.806,0a1.075,1.075,0,0,1,.614-.208.234.234,0,0,1,.169.1A.126.126,0,0,1,272.432,384.581Z",
    transform: "translate(-257.628 -327.215)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M275.191,244.056c-.63-1.011-4.309-2.827-4.594-2.986l-1.017,2.362c1.465.851,3.629,2.028,3.5,2.856Z",
    transform: "translate(-256.346 -230.491)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M265.666,237.706c-1.283-.718-4.335-2.924-5.767-1.482a2.542,2.542,0,0,0,1.3,3.217c.884.526,2.343,1.465,2.924,1.81Z",
    transform: "translate(-249.695 -226.896)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(10.033 8.849)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M265.666,237.706c-1.283-.718-4.335-2.924-5.767-1.482a2.542,2.542,0,0,0,1.3,3.217c.884.526,2.343,1.465,2.924,1.81Z",
    transform: "translate(-259.729 -235.745)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Character--inject-452--inject-61",
    transform: "translate(0 8.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M296.921,406.044a6.929,6.929,0,0,0,3.032.224c.309-.023.432.708-.279.926s-2.274.65-2.794.8c-.835.257-1.3.458-1.972.65a.19.19,0,0,1-.058,0,.257.257,0,0,1-.279-.237l-.13-1.625a.153.153,0,0,1,.11-.159l2.063-.65a.458.458,0,0,1,.309.072Z",
    transform: "translate(-273.127 -350.657)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M236.538,237.827c.231-.107.468-.214.7-.325a34.9,34.9,0,0,1,3.789-1.352q.253-.068.478-.117c.546-.12,1.1-.214,1.651-.283a1.03,1.03,0,0,1,1.017.484c.673,1.111,2.209,4.383,4.9,13.819l-8.916,3.217c-.279-.669-.8-2.726-1.706-5.368-.387-1.128-.842-2.356-1.381-3.633a39.911,39.911,0,0,0-2.681-5.3A23.569,23.569,0,0,1,236.538,237.827Z",
    transform: "translate(-232.59 -235.741)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M236.538,237.827c.231-.107.468-.214.7-.325a34.9,34.9,0,0,1,3.789-1.352q.253-.068.478-.117c.546-.12,1.1-.214,1.651-.283a1.03,1.03,0,0,1,1.017.484c.673,1.111,2.209,4.383,4.9,13.819l-8.916,3.217c-.279-.669-.8-2.726-1.706-5.368-.387-1.128-.842-2.356-1.381-3.633a39.911,39.911,0,0,0-2.681-5.3A23.569,23.569,0,0,1,236.538,237.827Z",
    transform: "translate(-232.59 -235.741)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M238.47,251.792c.5.975.952,1.966,1.358,2.924.107.257.211.51.325.764a7.473,7.473,0,0,0,0-4.27Z",
    transform: "translate(-235.344 -246.184)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M269.63,280.5s.127.062,2.778,10.157l3.785,7.753,6.05-2.395-9.381-16.838Z",
    transform: "translate(-256.38 -265.066)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285",
    transform: "translate(13.251 14.114)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M269.63,280.5s.127.062,2.778,10.157l3.785,7.753,6.05-2.395-9.381-16.838Z",
    transform: "translate(-269.63 -279.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M276.874,311.714c-1.56-3.025-3.334-6.583-4.874-9l.6-1.017C274.4,302.915,276.136,308.621,276.874,311.714Z",
    transform: "translate(-257.979 -280.268)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M252.16,284.813l2.752,10.476a41.455,41.455,0,0,0,2.109,7.542L263.3,301l-2.547-10.115c-1.374-5.007-2.141-8.4-2.141-8.4Z",
    transform: "translate(-244.586 -267.293)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286",
    transform: "translate(7.574 15.187)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M252.16,284.813l2.752,10.476a41.455,41.455,0,0,0,2.109,7.542L263.3,301l-2.547-10.115c-1.374-5.007-2.141-8.4-2.141-8.4Z",
    transform: "translate(-252.16 -282.48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M302.085,405.432a.533.533,0,0,0,.3-.188A.247.247,0,0,0,302.4,405a.127.127,0,0,0-.1-.091c-.218-.039-.65.465-.712.523a.039.039,0,0,0,0,.046.042.042,0,0,0,.039.023A2.056,2.056,0,0,0,302.085,405.432Zm.143-.429a.107.107,0,0,1,.052,0,.052.052,0,0,1,.039.039.162.162,0,0,1,0,.162.845.845,0,0,1-.591.218,1.708,1.708,0,0,1,.51-.4Z",
    transform: "translate(-277.946 -349.938)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M301.552,404.927h.016c.146-.149.374-.624.276-.806a.133.133,0,0,0-.159-.065.234.234,0,0,0-.156.1,1.3,1.3,0,0,0-.032.747.045.045,0,0,0,.029.029Zm.13-.79h.02c.049-.016.065,0,.068.023.058.1-.072.452-.208.65a1.02,1.02,0,0,1,.039-.591.143.143,0,0,1,.081-.081Z",
    transform: "translate(-277.865 -349.362)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M231.168,248.73c-.133.325-.237.621-.344.929s-.2.611-.3.923c-.188.617-.357,1.241-.5,1.878a17.849,17.849,0,0,0-.468,3.958v.221a1.441,1.441,0,0,0,.029.234,2.547,2.547,0,0,0,.114.409l.071.182c.023.059.059.1.078.159l.081.156.088.136a5.757,5.757,0,0,0,.734.9,11.581,11.581,0,0,0,1.573,1.3,20.866,20.866,0,0,0,3.4,1.911l.666-1.15c-.461-.37-.952-.754-1.417-1.137s-.926-.777-1.355-1.18a11.565,11.565,0,0,1-1.166-1.225,3.333,3.333,0,0,1-.383-.582l-.029-.065-.016-.052v-.055a.138.138,0,0,0,0-.033v-.042h0v-.02a16.241,16.241,0,0,1,.237-1.683c.114-.569.24-1.144.4-1.712s.325-1.141.5-1.709c.088-.286.179-.569.276-.851l.283-.822Z",
    transform: "translate(-229.329 -244.51)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M233.812,247.3c-.325,2.167-.855,4.464-.855,4.464L228.85,250s.292-4.309,1.8-5.088C232.473,243.975,234.176,244.946,233.812,247.3Z",
    transform: "translate(-228.85 -241.694)",
    fill: "#ce8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M233.812,247.3c-.325,2.167-.855,4.464-.855,4.464L228.85,250s.292-4.309,1.8-5.088C232.473,243.975,234.176,244.946,233.812,247.3Z",
    transform: "translate(-228.85 -241.694)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M247.74,285.5c.26.8,1.8.478,1.8.478l.023-2.274-1.625.741Z",
    transform: "translate(-241.602 -268.117)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M253.309,283.75l-.019,2.261,1.355-.045.1-1.868Z",
    transform: "translate(-245.349 -268.151)",
    fill: "#7f3e3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M243.71,232.6l.185.12c.24.156.481.325.731.458h0a9.994,9.994,0,0,0,2.44.429,3.151,3.151,0,0,0,.689-.708,1.052,1.052,0,0,0-.036-.549.692.692,0,0,0-.123-.224,1.381,1.381,0,0,1-.861-.474.839.839,0,0,1-.1-.146,2.518,2.518,0,0,1-.214-1.485l-2.71-1.625C244.129,229.518,244.695,231.714,243.71,232.6Z",
    transform: "translate(-238.882 -221.938)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M247.192,231.106c.146.546,1.134,1.5,1.517,1a3.858,3.858,0,0,1,0-.7l-1.605-.975A1.885,1.885,0,0,0,247.192,231.106Z",
    transform: "translate(-241.171 -223.308)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M251.9,218.766l.279.728a4.834,4.834,0,0,0,1.261-.13,1.3,1.3,0,0,1-.3-.689c.023-.305.474-.393.546-.705s-.085-1.3-.361-1.329-1.933.019-1.933.019C250.22,217.264,251.9,218.766,251.9,218.766Z",
    transform: "translate(-243.786 -213.993)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M244.228,215.507a2.333,2.333,0,0,1,3.178-.9c1.582.871,1.517,3.418.975,4.9a2.277,2.277,0,0,1-3.932.712c-.754-.975-.611-1.969-.513-3.678A2.3,2.3,0,0,1,244.228,215.507Z",
    transform: "translate(-238.98 -212.424)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M241.41,221.258l-.169-1.017,1.141.452a5.088,5.088,0,0,1-.455-1.9c.026-.3.351-.4.429-.712s-.088-1.319-.364-1.332-1.67,0-1.67,0C239.152,217.349,241.41,221.258,241.41,221.258Z",
    transform: "translate(-236.367 -214.068)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M252.05,223.189c.088,0,.149.13.133.27s-.1.244-.192.234-.153-.133-.136-.273S251.962,223.179,252.05,223.189Z",
    transform: "translate(-244.378 -218.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M256.618,223.51c.091,0,.172.1.182.24s-.058.257-.149.263-.172-.1-.182-.244S256.527,223.513,256.618,223.51Z",
    transform: "translate(-247.494 -218.637)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M254.59,225.436a.809.809,0,0,0,.676-.045,5.1,5.1,0,0,1-.523-1.261Z",
    transform: "translate(-246.226 -219.055)",
    fill: "#ba4d3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M250.672,220.786h0a.081.081,0,0,1,0-.114.819.819,0,0,1,.718-.2h0a.081.081,0,0,1,.055.1.084.084,0,0,1-.1.058.65.65,0,0,0-.565.169.094.094,0,0,1-.071.02A.072.072,0,0,1,250.672,220.786Z",
    transform: "translate(-243.566 -216.572)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M257.044,221.028a.65.65,0,0,0-.5-.305h0a.091.091,0,0,1-.071-.071.081.081,0,0,1,.071-.091.809.809,0,0,1,.65.38h0a.075.075,0,0,1-.026.1.045.045,0,0,1-.036,0A.078.078,0,0,1,257.044,221.028Z",
    transform: "translate(-247.494 -216.645)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M241.65,222.671c.5.084.764.822.786,1.3.026.539-.325.933-.773.63a1.709,1.709,0,0,1-.692-1.014C240.844,223.1,241.149,222.586,241.65,222.671Z",
    transform: "translate(-237.013 -218.064)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M252.377,229.406a4.618,4.618,0,0,0-.185.621h-.114c-.517-.036-.744-.224-.838-.419a.65.65,0,0,1-.062-.309.6.6,0,0,1,.026-.179,2.486,2.486,0,0,0,1,.279Z",
    transform: "translate(-243.923 -222.424)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M252.183,229.419l-.059.179a1.537,1.537,0,0,1-.975-.279.6.6,0,0,1,.026-.179A2.486,2.486,0,0,0,252.183,229.419Z",
    transform: "translate(-243.904 -222.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M252.258,231.019c-.517-.036-.744-.224-.838-.419a1.709,1.709,0,0,1,.565.153A.617.617,0,0,1,252.258,231.019Z",
    transform: "translate(-244.086 -223.423)",
    fill: "#de5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M244.525,211.919a11.616,11.616,0,0,0-5.91.266,1.342,1.342,0,0,1-1.053-1.41,2.293,2.293,0,0,1,1.205-1.54,6.06,6.06,0,0,1,2.184-.692,5.246,5.246,0,0,1,2.349.354,2.962,2.962,0,0,1,1.7,1.2A1.459,1.459,0,0,1,244.525,211.919Z",
    transform: "translate(-234.729 -208.511)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M272.264,248.6l-6.024,3.1.016,1.27s6.278-1.238,6.989-2.209h0a1.625,1.625,0,0,0-.559-1.846Z",
    transform: "translate(-254.091 -235.574)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M262.108,258.083l-.929.452a1.232,1.232,0,0,0-.621.689l-.422,1.154a.305.305,0,0,0,.137.364l.725.393a.3.3,0,0,0,.383-.091l.744-1.043.744-1.2S262.465,257.907,262.108,258.083Z",
    transform: "translate(-249.959 -241.96)",
    fill: "#7f3e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M267.177,258.491l-.523.1-.643-1.4.471-.218Z",
    transform: "translate(-253.936 -241.231)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M.292,0H.864a.292.292,0,0,1,.292.292V.335H0V.292A.292.292,0,0,1,.292,0Z",
    transform: "translate(11.695 15.962) rotate(-24.71)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodatafaq);
export default __webpack_public_path__ + "static/media/nodatafaq.65c8c14301b9b2ea329b981933545725.svg";
export { ForwardRef as ReactComponent };